export const UPDATE_CANCEL_APPOINTMENT_MODAL_NAME = 'UpdateCancelInstructionsModal'
